<template>
  <v-card>
    <v-progress-linear
      absolute
      :active="loading"
      indeterminate
      color="primary"
      bottom
    ></v-progress-linear>
    <v-card-title>
      <span class="headline">Create Client</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <client-form :data="data"></client-form>
      </v-container>
    </v-card-text>
    <form-errors :errors="errors"></form-errors>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="_close">Cancel</v-btn>
      <v-btn
        :disabled="loading"
        v-if="Object.values(item).length > 0"
        color="blue darken-1"
        text
        @click="update"
        >Update</v-btn
      >
      <v-btn
        :disabled="loading"
        v-else
        color="blue darken-1"
        text
        @click="create"
        >Create</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import FormErrors from '../../../../components/FormErrors'
import { axios } from '../../../../utils'
import ClientForm from './ClientForm'
export default {
  name: 'ClientDialog',
  data() {
    return {
      data: {
        client_name: '',
        business_name: '',
        website: '',
        email: '',
        unit: '',
        street: '',
        suburb: '',
        telephone: '',
        mobile: '',
        abn: '',
        acn: '',
        notes: ''
      },
      loading: false,
      errors: []
    }
  },
  props: ['close', 'clients', 'item'],
  components: {
    ClientForm,
    FormErrors
  },
  computed: {
    ...mapState({ payAsYouGo: state => state.clients.payAsYouGo })
  },
  mounted() {
    if (this.item.id) {
      this.loading = true
      console.log('getting clients data for id ', this.item.id)
      axios
        .get('api/admin/clients/' + this.item.id)
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.data = res.data
          this.data.suburb = res.data.suburb.name
          this.loading = false
        })
        .catch(err => console.log(err))
    }
  },
  methods: {
    create() {
      this.loading = true
      console.log('creating new client')
      axios
        .post('api/admin/clients/create', {
          ...this.data,
          pay_as_you_go: this.payAsYouGo
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this.loading = false
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    update() {
      this.loading = true
      console.log('updating client data for id ', this.item.id)
      axios
        .put(`api/admin/clients/${this.item.id}`, {
          ...this.data,
          pay_as_you_go: this.payAsYouGo
        })
        .then(res => {
          console.log(res.data)
          console.log('done')
          this._close()
        })
        .catch(err => {
          if (err.response.status === 422) {
            this.errors = Object.values(err.response.data.errors)
          } else {
            console.log(err.response)
          }
        })
        .finally(() => (this.loading = false))
    },
    _close() {
      this.clearData()
      this.close()
    },
    clearData() {
      this.data = {
        client_name: '',
        business_name: '',
        website: '',
        email: '',
        unit: '',
        street: '',
        suburb: '',
        telephone: '',
        mobile: '',
        abn: '',
        acn: '',
        notes: ''
      }
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped></style>
